import { render, staticRenderFns } from "./CorpFlowVotesPage.vue?vue&type=template&id=004a5b28&scoped=true"
import script from "./CorpFlowVotesPage.vue?vue&type=script&lang=js"
export * from "./CorpFlowVotesPage.vue?vue&type=script&lang=js"
import style0 from "./CorpFlowVotesPage.vue?vue&type=style&index=0&id=004a5b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004a5b28",
  null
  
)

export default component.exports